<div [id]="containerId" style="min-width:320px;height:700px"></div>
